import { render, staticRenderFns } from "./ModalMediateAppointmentDetail.vue?vue&type=template&id=683b8570&"
import script from "./ModalMediateAppointmentDetail.vue?vue&type=script&lang=js&"
export * from "./ModalMediateAppointmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports